import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	menuLinkItemAriaLabel: {
		id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
		description:
			'Accessibility label for individual app shortcut items in the global shortcuts menu. The placeholder {appName} is substituted with the application name (e.g., "Jira", "Confluence"), and {siteName} is substituted with the site name if applicable (e.g., " - Engineering"). Example: "Jira - Engineering". Assistive technologies use this label to announce the app and site context to users.',
		defaultMessage: '{appName}{siteName}',
	},
});
